
import Vue from 'vue'

export default (sinister) => {
  return Vue.$http.put(`sinisters/roads/${sinister.id}/dua_type/`, {sinister_dua_type: sinister.roadSinisterTypeId})
    .then(response => {
      return sinister
    })
}



// WEBPACK FOOTER //
// ./src/services/sinister/changeSinisterTypeDUA.js